var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "pricing--section"
  }, [_c('a', {
    attrs: {
      "id": "pricing"
    }
  }), _vm._v(" "), !_vm.wrapSlot ? _vm._t("default") : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section--container",
    class: {
      wide: !_vm.isPlanStage
    }
  }, [_c('div', {
    staticClass: "section--content"
  }, [_vm.wrapSlot ? _vm._t("default") : _vm._e(), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "billing-cycle--container"
  }, _vm._l(['Monthly', 'Annual'], function (cycle, index) {
    return _c('div', {
      key: cycle,
      staticClass: "billing-cycle--option",
      class: {
        active: _vm.billingCycle === index,
        white: !_vm.cycleSelected
      },
      on: {
        "click": () => _vm.selectBillingCycle(index)
      }
    }, [index === 1 ? _c('span', {
      staticClass: "badge--discount"
    }, [_vm._v("Up to $" + _vm._s(_vm.maxAnnualSavings) + " savings")]) : _vm._e(), _vm._v("\n\t\t\t\t\t" + _vm._s(cycle) + "\n\t\t\t\t")]);
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row items-center justify-center my-12 space-x-16 sm-md:space-x-0 sm-md:flex-col sm-md:my-0",
    class: !_vm.cycleSelected && 'section-disabled'
  }, [_c('div', {
    staticClass: "plan--container sm-md:mt-6 sm-md:mb-4"
  }, _vm._l(_vm.plans, function (plan, index) {
    return _c('div', {
      key: index,
      staticClass: "plan--column",
      class: {
        active: _vm.selectedPlan === index,
        default: _vm.selectedPlan === -1,
        popular: plan.most_popular
      },
      on: {
        "click": () => _vm.selectPlan(index)
      }
    }, [_vm.savings[index][_vm.billingCycle] ? _c('span', {
      staticClass: "badge--discount"
    }, [_vm._v("$" + _vm._s(_vm.savings[index][_vm.billingCycle]) + " annual savings")]) : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "plan--icon",
      attrs: {
        "src": plan.icon
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "plan--title"
    }, [_vm._v(_vm._s(plan.title))]), _vm._v(" "), _c('p', {
      staticClass: "plan--heading"
    }, [_vm._v(_vm._s(plan.heading))]), _vm._v(" "), _c('div', {
      staticClass: "plan--mobile-content"
    }, [_c('p', {
      staticClass: "plan--title-mobile"
    }, [plan.most_popular ? _c('span', {
      staticClass: "badge--most-popular"
    }, [_vm._v("Most popular")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(plan.mobile.title))])]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade",
        "mode": "out-in"
      }
    }, [_c('p', {
      key: _vm.billingCycle,
      staticClass: "plan--pricing-mobile"
    }, [plan.displayOnlyFullPrice[_vm.billingCycle] ? _c('span', {
      staticClass: "text-red-400 text-base line-through"
    }, [_vm._v("$" + _vm._s(plan.displayOnlyFullPrice[_vm.billingCycle]))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(plan.price[_vm.billingCycle]) + "/" + _vm._s(_vm.billingCycle === 0 ? 'month' : 'year'))])])])], 1), _vm._v(" "), _c('ul', {
      staticClass: "plan--features"
    }, _vm._l(plan.features, function (feature, featureIndex) {
      return _c('li', {
        key: featureIndex
      }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(feature) + "\n\t\t\t\t\t\t\t")]);
    }), 0), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade",
        "mode": "out-in"
      }
    }, [_c('div', {
      key: _vm.billingCycle,
      staticClass: "plan--pricing-group scale-100-edge"
    }, [_c('div', {
      staticClass: "plan--pricing"
    }, [_c('p', {
      staticClass: "plan--pricing-amount"
    }, [_vm._v(_vm._s(plan.price[_vm.billingCycle]))]), _vm._v(" "), _c('p', {
      staticClass: "plan--pricing-cycle"
    }, [_vm._v("Per"), _c('br'), _vm._v("month")])]), _vm._v(" "), _c('p', {
      staticClass: "plan--billing-cycle"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\tBilled\n\t\t\t\t\t\t\t\t\t" + _vm._s(['Monthly', `as one annual payment of $${plan.price[1]}`][_vm.billingCycle]) + "\n\t\t\t\t\t\t\t\t")])])])], 1);
  }), 0), _vm._v(" "), _vm.showFeatures ? _c('div', {
    staticClass: "pricing--mobile-plan-features"
  }, [_c('ul', _vm._l(_vm.planFeatures, function (feature, index) {
    return _c('li', {
      key: feature,
      class: {
        active: _vm.plans[_vm.selectedPlan] && _vm.plans[_vm.selectedPlan].mobile.features.includes(index)
      }
    }, [_c('svg', {
      attrs: {
        "width": "21",
        "height": "15",
        "viewBox": "0 0 21 15",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M18.126 0.455205L6.61231 11.0499L2.91071 7.47097C2.24715 6.82939 1.16751 6.82939 0.500362 7.47097C-0.166787 8.11255 -0.166787 9.15642 0.500362 9.80147L5.37845 14.5179C5.71202 14.8405 6.14603 15 6.58362 15C7.00686 15 7.43011 14.8474 7.75651 14.5457L20.4718 2.84119C21.1533 2.21348 21.1784 1.16961 20.5292 0.510693C19.88 -0.148227 18.8075 -0.172503 18.126 0.455205Z",
        "fill": "currentColor"
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(feature))])]);
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col items-center -mt-6 mb-8 _sm-md:flex-col-reverse sm-md:mt-3"
  }, [_vm.pickMandatory ? _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('span', {
    key: _vm.selectedPlan + _vm.billingCycle,
    staticClass: "block mb-8 text-3xl font-medium font-sans _sm-md:mt-6 sm-md:text-2xl"
  }, [_vm.showPricingSummary && _vm.plans[_vm.selectedPlan] ? _c('pricing-summary', {
    attrs: {
      "plan": _vm.plans[_vm.selectedPlan],
      "billing-cycle": _vm.billingCycle,
      "label": "Billed"
    }
  }) : _vm.plans[_vm.selectedPlan] ? _c('span', [_vm._v("Billed $" + _vm._s(_vm.plans[_vm.selectedPlan].price[_vm.billingCycle]) + "/" + _vm._s(_vm.billingCycle === 0 ? 'month' : 'year'))]) : _c('span', {
    staticClass: "opacity-0"
  }, [_vm._v("-")])], 1)]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [!_vm.selected ? _c('button', {
    key: 'pick',
    staticClass: "button--filled -mt-4 sm-md:-mt-8 mb-4 sm-md:mb-8 sm:w-full",
    class: {
      'w-full': !_vm.isPlanStage
    },
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("\n\t\t\t\t\t\tPick a plan to continue\n\t\t\t\t\t")]) : _c('button', {
    key: 'complete',
    staticClass: "button--filled sm:w-full",
    class: {
      'w-full': !_vm.isPlanStage
    },
    attrs: {
      "name": "submit-plan"
    },
    on: {
      "click": _vm.continueButtonAction
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.continueButtonTitle) + "\n\t\t\t\t\t")])]), _vm._v(" "), _vm._t("button")], 2), _vm._v(" "), !_vm.pickMandatory ? _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.plans[_vm.selectedPlan] ? _c('span', {
    key: _vm.selectedPlan + _vm.billingCycle,
    staticClass: "block mt-8 -mb-6 italic opacity-50 text-md"
  }, [_c('span', [_vm._v("Billed as")]), _vm._v(" "), _vm.plans[_vm.selectedPlan] ? _c('span', [_vm.billingCycle === 0 ? _c('span', [_vm._v("a monthly payment of $" + _vm._s(_vm.plans[_vm.selectedPlan].price[0]))]) : _c('span', [_vm._v("an annual payment of $" + _vm._s(_vm.plans[_vm.selectedPlan].price[1]))])]) : _vm._e()]) : _c('span', {
    staticClass: "block mt-8 -mb-6 italic opacity-0 text-md"
  }, [_c('span', [_vm._v("-")])])]) : _vm._e(), _vm._v(" "), _vm.footer ? _c('p', {
    directives: [{
      name: "sani-html",
      rawName: "v-sani-html",
      value: _vm.footer,
      expression: "footer"
    }],
    staticClass: "mt-4 text-sm color--dark--grey"
  }) : _vm._e(), _vm._v(" "), _vm._t("footer")], 2)])], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };